import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/icon-close-btn.png'
import _imports_1 from '@/assets/images/logo.svg'
import _imports_2 from '@/assets/images/logo-top.png'
import _imports_3 from '@/assets/images/logo-new.png'
import _imports_4 from '@/assets/images/pagetop-img.png'
import _imports_5 from '@/assets/images-sp/icon01-02.png'
import _imports_6 from '@/assets/images-sp/icon02-02.png'
import _imports_7 from '@/assets/images-sp/icon03-02.png'
import _imports_8 from '@/assets/images-sp/icon04-02.png'
import _imports_9 from '@/assets/images/icon-facebook.png'
import _imports_10 from '@/assets/images/icon-x.png'
import _imports_11 from '@/assets/images/icon-youtube.png'
import _imports_12 from '@/assets/images/icon-tiktok.png'


const _hoisted_1 = { class: "drawer drawer--right" }
const _hoisted_2 = {
  class: "drawer-nav",
  ref: "drawerRef"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "drawer-nav-close-btn drawer-toggle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "19",
    height: "33"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/" }, "スズキ四輪車TOP")
], -1)
const _hoisted_5 = { class: "sp-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.suzuki.co.jp/car/",
  class: "mobi"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-left-logo",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "img-banner" }, "スズキ定額マイカー", -1)
const _hoisted_8 = { class: "head-in-info right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { class: "menu-btn drawer-toggle" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "kotei-head-info-btn-list right of pc tab"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "宮城", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "福岡", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "埼玉", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "大阪", -1)
const _hoisted_15 = { class: "head-row of" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "img-banner" }, "スズキ定額マイカー", -1)
const _hoisted_17 = { class: "kotei-head-info right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { class: "menu-btn drawer-toggle" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "kotei-head-info-btn-list right of pc tab"
}
const _hoisted_20 = { class: "right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "宮城", -1)
const _hoisted_22 = { class: "right" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "福岡", -1)
const _hoisted_24 = { class: "right" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "埼玉", -1)
const _hoisted_26 = { class: "right" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "大阪", -1)
const _hoisted_28 = {
  key: 0,
  class: "header-logo"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_30 = { class: "page" }
const _hoisted_31 = { class: "foot-in" }
const _hoisted_32 = { class: "wrapper" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  width: "649",
  height: "90"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "pagetop pc tab" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "71",
    height: "70"
  })
], -1)
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<ul class=\"foot-sp-menu-list of mobi\"><li class=\"li-1\"><a href=\"https://www.suzuki.co.jp/dealer/Map2/getPref/buycar\" target=\"_blank\"><span class=\"foot-sp-menu-list-in\"><span class=\"foot-sp-menu-list-in-img\"><img src=\"" + _imports_5 + "\" width=\"62\" height=\"46\"></span><span class=\"foot-sp-menu-list-in-title\">販売店検索</span></span></a></li><li class=\"li-2\"><a href=\"/car/purchase/democar/\"><span class=\"foot-sp-menu-list-in\"><span class=\"foot-sp-menu-list-in-img\"><img src=\"" + _imports_6 + "\" width=\"60\" height=\"46\"></span><span class=\"foot-sp-menu-list-in-title\">展示車<br>試乗車検索</span></span></a></li><li class=\"li-3\"><a href=\"/car/purchase/estimate/\"><span class=\"foot-sp-menu-list-in\"><span class=\"foot-sp-menu-list-in-img\"><img src=\"" + _imports_7 + "\" width=\"62\" height=\"46\"></span><span class=\"foot-sp-menu-list-in-title\">オンライン<br>見積り</span></span></a></li><li class=\"li-4\"><a href=\"https://krs.bz/suzuki/m?f=166\"><span class=\"foot-sp-menu-list-in\"><span class=\"foot-sp-menu-list-in-img\"><img src=\"" + _imports_8 + "\" width=\"62\" height=\"46\"></span><span class=\"foot-sp-menu-list-in-title\">カタログ請求</span></span></a></li><li class=\"li-pagetop\"><a></a></li></ul>", 1)
const _hoisted_36 = { class: "foot-main" }
const _hoisted_37 = { class: "wrapper" }
const _hoisted_38 = { class: "of" }
const _hoisted_39 = { class: "foot-main-menu-list of" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.suzuki.co.jp/car/" }, "スズキ四輪車TOP")
], -1)
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"foot-main-2\"><div class=\"wrapper new of\"><section class=\"sec-1\"><div class=\"foot-main-2-new-in\"><a href=\"/car/lineup/\" class=\"foot-main-2-new-in-title\"> ラインアップ </a><ul><li><a href=\"/car/lineup/#lightLineup\">乗用車/軽自動車</a></li><li><a href=\"/car/lineup/#welfareLineup\">福祉車両</a></li><li><a href=\"/car/lineup/#commercialLineup\">ビジネスカー/商用車</a></li></ul></div><div class=\"foot-main-2-new-in\"><a href=\"/car/buying/\" class=\"foot-main-2-new-in-title\"> 購入をお考えの方 </a><div class=\"of\"><ul class=\"pc-left\"><li><a href=\"https://www.suzuki.co.jp/dealer/Map2/getPref/buycar\" target=\"_blank\">販売店検索</a></li><li><a href=\"/car/purchase/estimate/\">オンライン見積り</a></li><li><a href=\"/car/purchase/democar/\">展示車・試乗車検索</a></li><li><a href=\"https://krs.bz/suzuki/m?f=166\" target=\"_blank\">カタログ請求</a></li><li><a href=\"/accessory_car/\" target=\"_blank\">アクセサリー</a></li><li><a href=\"/ucar/\" target=\"_blank\">中古車検索</a></li><li><a href=\"/car/teigakumycar/\" target=\"_blank\">定額マイカー<br class=\"mobi\">（サブスクリプションサービス）</a></li></ul><ul class=\"pc-left\"><li><a href=\"/car/information/9navi/\">カーナビ</a></li><li><a href=\"/car/goods/\">車中泊GOODS LINE UP</a></li><li><a href=\"/car/smile_car_life/\">スマイルカーライフ</a></li><li><a href=\"https://www.suzuki-finance.co.jp/credit/\" target=\"_blank\">クレジットのご案内</a></li></ul></div></div></section><section class=\"sec-2\"><div class=\"foot-main-2-new-in\"><a href=\"/car/afterservice/\" class=\"foot-main-2-new-in-title\"> オーナーの方 </a><ul><li><a href=\"/car/afterservice/safetycheck/\">車検・整備</a></li><li><a href=\"/car/owners_manual/index_2.html\" target=\"_blank\">オーナーズマニュアル</a></li><li><a href=\"/car/afterservice/rescuemanual/\">レスキューマニュアル</a></li><li><a href=\"/car/carlife/\">カーライフサポート</a></li><li><a href=\"https://www.suzuki.co.jp/dealer/Map2/getPref/buycar\" target=\"_blank\">販売店検索</a></li><li><a href=\"https://www.suzuki.co.jp/dealer/Contact/addresschange/maker/\" target=\"_blank\">転居のご案内</a></li></ul></div><div class=\"foot-main-2-new-in\"><a href=\"/car/entertainment/\" class=\"foot-main-2-new-in-title\"> スズキを楽しむ </a><ul><li><a href=\"/car/entertainment/motorshow/\">イベント・モーターショー</a></li><li><a href=\"/about/museum/\">スズキを知る</a></li><li><a href=\"/car/entertainment/tvcm/\">テレビCM情報</a></li></ul></div></section><section class=\"sec-3\"><div class=\"foot-main-2-new-in\"><a href=\"https://krs.bz/suzuki/m?f=41\" class=\"foot-main-2-new-in-title\"> メールマガジン登録 </a><div class=\"foot-main-2-new-text\"> メールマガジンにご登録いただくことで、スズキの最新情報や便利なサービスなどの情報をご提供させていただきます。 </div><a href=\"https://krs.bz/suzuki/m?f=41\" class=\"foot-main-2-new-link-btn\"><span>登録・変更・停止申し込み</span></a></div><div class=\"foot-main-2-new-in\"><a href=\"\" class=\"foot-main-2-new-in-title\"> 公式SNS </a><ul class=\"foot-main-2-new-in-sns-list of\"><li><a href=\"https://www.facebook.com/suzukicojp/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"foot-main-2-new-in-sns-list-img\"><img src=\"" + _imports_9 + "\" width=\"100\" height=\"100\"></a></li><li><a href=\"https://x.com/suzukicojp\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"foot-main-2-new-in-sns-list-img\"><img src=\"" + _imports_10 + "\" width=\"100\" height=\"100\"></a></li><li><a href=\"https://www.youtube.com/user/suzukicojp\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"foot-main-2-new-in-sns-list-img\"><img src=\"" + _imports_11 + "\" width=\"100\" height=\"100\"></a></li><li><a href=\"https://www.tiktok.com/@suzukicojp\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"foot-main-2-new-in-sns-list-img\"><img src=\"" + _imports_12 + "\" width=\"100\" height=\"100\"></a></li></ul><a href=\"/car/socialmedia_policy/\" class=\"foot-main-2-new-in-link\">ソーシャルメディア利用規約</a></div></section></div></div><div class=\"foot-main-3\"><div class=\"wrapper of\"><ul class=\"foot-main-3-list of\"><li><a href=\"/sitemap/\">サイトマップ</a></li><li><a href=\"/foruse/\">ご利用にあたって</a></li><li><a href=\"/privacy_statement/\">個人情報の取り扱いについて</a></li></ul><div class=\"foot-main-3-copyright\"> © Suzuki Motor Corporation, 2022. All rights reserved. </div></div></div>", 2)
const _hoisted_43 = { class: "kotei-foot-link mobi" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "kotei-foot-link-title sans" }, " 利用可能なクルマを探す ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_yonrin_header = _resolveComponent("yonrin-header")!
  const _component_mail_magazine_form = _resolveComponent("mail-magazine-form")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/#" }, {
            default: _withCtx(() => [
              _createTextVNode("TOP")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/service" }, {
            default: _withCtx(() => [
              _createTextVNode("サービス詳細")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/flow" }, {
            default: _withCtx(() => [
              _createTextVNode("ご利用の流れ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/shop" }, {
            default: _withCtx(() => [
              _createTextVNode("店舗情報")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/faq" }, {
            default: _withCtx(() => [
              _createTextVNode("よくある質問")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/inquiry" }, {
            default: _withCtx(() => [
              _createTextVNode("お問い合わせ")
            ]),
            _: 1
          })
        ]),
        _hoisted_4
      ])
    ], 512),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("header", null, [
        _createVNode(_component_yonrin_header),
        _createElementVNode("div", {
          class: _normalizeClass({ 'head-in': true, of: true, 'head-in-none': !_ctx.showHeadIn, 'with-center-logo': !_ctx.top })
        }, [
          _hoisted_6,
          (!_ctx.top)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/",
                class: "center-logo pc tab"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.showHeadButton)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode("エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createTextVNode("エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createTextVNode("エリアで探す")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({ 'kotei-head': true, 'no-btn': !_ctx.showHeadButton })
        }, [
          _createVNode(_component_yonrin_header),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "center-logo"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              (_ctx.showHeadButton)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    _createElementVNode("li", _hoisted_20, [
                      _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createTextVNode("エリアで探す")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createTextVNode("エリアで探す")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createTextVNode("エリアで探す")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_26, [
                      _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _createTextVNode("エリアで探す")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        (_ctx.top)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_router_link, {
                class: "header-logo-link",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("footer", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (!_ctx.hideMagazineForm)
              ? (_openBlock(), _createBlock(_component_mail_magazine_form, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "foot-in-logo-img"
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_34
          ])
        ]),
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("ul", null, [
                  _hoisted_40,
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _createTextVNode("スズキ定額マイカーTOP")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
                      default: _withCtx(() => [
                        _createTextVNode("埼玉エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
                      default: _withCtx(() => [
                        _createTextVNode("大阪エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
                      default: _withCtx(() => [
                        _createTextVNode("宮城エリアで探す")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
                      default: _withCtx(() => [
                        _createTextVNode("福岡エリアで探す")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/service" }, {
                      default: _withCtx(() => [
                        _createTextVNode("サービス詳細")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/flow" }, {
                      default: _withCtx(() => [
                        _createTextVNode("ご利用の流れ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/faq" }, {
                      default: _withCtx(() => [
                        _createTextVNode("よくある質問")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/terms/use" }, {
                      default: _withCtx(() => [
                        _createTextVNode("利用規約")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/terms/tokushouhou" }, {
                      default: _withCtx(() => [
                        _createTextVNode("特定商取引法に基づく表示")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/terms/privacy" }, {
                      default: _withCtx(() => [
                        _createTextVNode("個人情報に関する取扱い")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_41
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
              default: _withCtx(() => [
                _createTextVNode("埼玉エリアで探す")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
              default: _withCtx(() => [
                _createTextVNode("大阪エリアで探す")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
              default: _withCtx(() => [
                _createTextVNode("宮城エリアで探す")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
              default: _withCtx(() => [
                _createTextVNode("福岡エリアで探す")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}